import notify from "devextreme/ui/notify";

/**
 * @file
 * This module only contains helper functions that can be shared across RMS.
 */

/**
 * @function
 * @name sortRegions
 * @param integers[]
 * @description function accepts an array numbers. The function will convert 
 * each number to a string though mapping, sort each number, and join a comma
 * to each number (except the last index) for readablity
 * @returns An array of sorted regions
 */

export function sortRegions(regionStrings) {
    const strings = regionStrings.map(number => String(number));
    const comparator = (a, b) => a - b;
    const regions = strings.slice().sort(comparator).join(', ');

    return regions;
};


/**
 * @function
 * @name generateUID
 * @param array[]
 * @description function accepts an array. The function will operate over the
 * array by appending a new property (_uid) with a value of an integer that
 * begins at 0 (zero) and increments with each loop until the length of the
 * array is has been reached.
 * @returns The array - mutated to contain appended key values.
 */

export const generateUID = (array) => {
    let currentUIdValue = 0;

    array.forEach(label => {
        label._uid = currentUIdValue++;
    });

    return array;
};


/**
 * @function physicalAddressSplitter
 * @description Accepts a string - specifically, the key value of `address` from a single building. The function uses a regular express to split the string into the convention of a modern physical street address. Returns an array.
 * @param {string} value the value of the `address` property on a string
 * @returns {string[]}
 */

export const physicalAddressSplitter = (value) => {
    const match = value.match(/^([^,]+)(?:,\s*([^,]+))?,\s*([A-Za-z\s]+),\s*([A-Z]{2})\s*(\d{5}(?:-\d{4})?|\d{9})$/);
    let result;

    if (!match) {
        console.error('Invalid address format');
        return null;
    };

    if (match.length === 5) {
        result = {
            AddressOne: match[1] || '',
            CityName: match[2] || '',
            State: match[3] || '',
            ZipCode: match[4] || ''
        }
    };

    if (match.length === 6) {
        result = {
            AddressOne: match[1] || '',
            AddressTwo: match[2] || '',
            CityName: match[3] || '',
            State: match[4] || '',
            ZipCode: match[5] || ''
        }
    };

    return result;
};


/**
 * @function
 * @name validateZipCodeString
 * @param string
 * @description function a string that consists of number. Requires that the string contain numbers in the length of either five (5) or nine (9). If the length of the string contains more than five numbers, a hypen or `-` will be inserted between the fourth index and fifth index of the string.
 * @returns A validated string that resolves to true or false.
 */
export const validateZipCodeString = (string) => {
    return string = string.replace(/^(\d{5})(\d{1,4})?$/, "$1-$2").replace(/-$/, "")
};


/**
 * @function
 * @name showNotification
 * @param string message
 * @param boolean success
 * @param integer displayTime
 * @param integer width
 * @description accepts paramters that are passed into the notify() method of devextreme and is rendered immedately upon invocation
 */
export const showNotification = (
    message, 
    success, 
    displayTime = 3000, 
    width = 500 
) => {
    notify(
        {
            message: message,
            width: width,
            position: {
                at: 'top',
                my: 'top',
                of: '#container'
            }
        },
        success ? 'success' : 'error',
        displayTime
    );
};